import { ISanityImage } from '@rbi-ctg/menu';
import { IHeroMaskCardFragment, IImageFragment } from 'generated/sanity-graphql';

export interface IMainHero {
  image: ISanityImage | IImageFragment;
  mobileImage?: ISanityImage | IImageFragment;
  backgroundImage?: ISanityImage | IImageFragment;
  html: string | null;
  actionTo: string;
  heroTextColor: string | null;
  heroSuperText: string;
  heroActionText: string;
  heroSubText: string;
  heroMaskCards: IHeroMaskCardFragment[];
  heroActionLeft?: string;
  heroActionLeftLink?: string;
  heroActionLeftIcon?: ISanityImage | IImageFragment | null;
  heroActionRight?: string;
  heroActionRightLink?: string;
  heroActionRightIcon?: ISanityImage | IImageFragment | null;
}

export enum SanityHeroTextColor {
  White = 'white',
  Black = 'black',
}

export interface ISanityHeroTextProps {
  $sanityTextColor: string | null;
  $defaultTextColor: string;
}

export interface IHeroSuperText {
  $sanityTextColor: string | null;
  $defaultTextColor: string;
}
